// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1Fnll","nav":"Header_nav__16EUy","logo":"Header_logo__2i62G","transitar":"Header_transitar__2NKjC","login":"Header_login__V5AKa"};